import { H3 } from '@h3/types';
import { request } from '@h3/request';
import * as Api from './constant';

/** 发送短信 */
export const sendSms = (
    params: Array<{
        engineCode: string;
        address: string;
        subject: string;
        bizCode?: string;
        parameters?: Record<string, unknown>;
    }>,
) => {
    return request<H3.Http.Response.H3Response<boolean>>(Api.SendSms, {
        method: 'post',
        data: params,
    });
};

/** 获取短信模板列表 */
export const getSmsTemplateList = (params: { engineCode: string }) =>
    request<H3.Http.Response.H3Response<H3.Plugin.SmsTemplateModel[]>>(Api.SmsTemplateList, {
        method: 'get',
        params,
    });

/** 删除短信模板列表 */
export const removeSmsTemplate = (params: { id: string }) =>
    request<H3.Http.Response.H3Response<boolean>>(Api.SmsTemplateRemove, {
        method: 'post',
        data: params,
    });
